import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { AlertService } from 'src/app/services/auth';
import { AridosHistoryFacade } from '../aridos-history.facade';
import { AridosHistoryRow } from '../aridos-history.types';

@Component({
  selector: 'app-aridos-history-detail',
  templateUrl: './aridos-history-detail.component.html',
  styleUrls: ['./aridos-history-detail.component.css'],
  standalone: false,
})
export class AridosHistoryDetailComponent {
  @Input() order: AridosHistoryRow | null = null;
  @Input() isRejected: (order: AridosHistoryRow) => boolean = () => false;
  @Input() isDelivered: (order: AridosHistoryRow) => boolean = () => false;
  @Input() isPending: (order: AridosHistoryRow) => boolean = () => false;
  @Output() updated = new EventEmitter<void>();

  showDetalle = false;
  showAccion = false;

  constructor(
    private readonly historyFacade: AridosHistoryFacade,
    private readonly router: Router,
    private readonly alertService: AlertService,
  ) {}

  openDetalle(): void { this.showDetalle = true; }
  closeDetalle(): void { this.showDetalle = false; }
  openAccion(): void { this.showDetalle = false; this.showAccion = true; }
  closeAccion(): void { this.showAccion = false; }
  isSigned(order: AridosHistoryRow): boolean { return order.isSignature; }

  generateQr(): void {
    if (!this.order) return;
    this.historyFacade.regenerateQr(String(this.order.tkt), String(this.order.orderNumber)).subscribe({
      next: (data: any) => {
        if (data?.Estado === 'Insertado') {
          this.router.navigate(['/PedidosPendientes/Detalle'], { queryParams: { tkt: this.order?.tkt, paso: 3 } });
        } else {
          this.alertService.error('Error al generar QR.');
        }
      },
      error: () => this.alertService.error('Error al generar QR.'),
    });
  }

  moveToCurrentDispatch(): void {
    if (!this.order) return;
    this.historyFacade.setPendingOrder(String(this.order.tkt), String(this.order.orderNumber)).subscribe({
      next: (data: any) => {
        if (data?.Estado === 'Insertado') {
          this.closeAccion();
          this.updated.emit();
        }
      },
    });
  }
}
